<template>
  <div>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="selectLog" class="demo-form-inline">
        <el-form-item label="仓房选择">
          <el-select v-model="selectLog.wareId" clearable placeholder="仓房选择" @change='getselectInfo'>
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查询年份">
          <el-date-picker
            v-model="selectLog.year"
            type="year"
            value-format="yyyy"
            @change='getselectInfo'
            placeholder="开始时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <div class='setMacView airEnergy' :style="`height:${height-50}px;width:${width-60}px`">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              :max-height="height-70"
              border
            >
              <el-table-column 
                prop="wareName" 
                label="仓房名称" 
                align="center" 
                min-width='10%' 
                sortable>
              </el-table-column>
              <el-table-column
                prop="wareType"
                label="仓房类型"
                align="center"
                min-width='10%'
              >
              </el-table-column>
              <el-table-column
                label="月能耗"
                align="center"
                min-width='10%'
              >
              <el-table-column
                :label="`${item}月`"
                align="center"
                min-width='10%'
                v-for="(item,index) in 12"
                :key='index'
              >
              <template slot-scope="scope">
                {{scope.row.monthData[index]}}
              </template>
              </el-table-column>
              </el-table-column>
              <el-table-column
                prop="znh"
                label="年度总能耗"
                align="center"
                min-width='10%'
                sortable
              >
              </el-table-column>
              
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      selectLog:{
        pageNum:1,
        pageSize:14,
        orderByColumn:'createTime',
        isAsc:'desc',
        wareId:'',
        year:''
      },
      wareList:[],
      tableData:[],
    }

  },
  created(){
    this.getWareList()
  },
  methods:{
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          this.wareList=res.data;
          this.getselectInfo()
        }
      })
    },
    getselectInfo(){
      axios.get('/system/energyHis/summary',{params:this.selectLog}).then(res=>{
        if(res.code==200){
          this.tableData=res.data;
        }
      })
    }
  }
}
</script>

<style>
.oilonLine{color: #3BD14A}
.oiloffLine{color: #AFAFAF}
.delMoreHistory{left: 15px;}
.airEnergy{
  border: 1px solid red;
  top: 15px !important;
}
</style>
